// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const APP_VERSION = "5.0"

export const releaseTime = "16:30 Jan 3, 2024"

export const environment = {
  production: true,
  google_client_id: "675456115635-b0pvhnn5hat9ohs3v4k1u83j0sueoahm.apps.googleusercontent.com" // Google Client ID for ProductDev Edge
};

export const backend = "https://backend.productdevedge.com/"
export const frontend = "https://productdevedge.com/"
export const backendWsHost = "wss://backend.productdevedge.com"
export const rzp_key = "rzp_live_uJ7Lb3oNjVbtg8"
export const wip = false
export const wipStatus = "updates on ingredient research"
export const ENV = "prod"

// User activity monitoring configuration
export const USER_ACTIVITY_CONFIG = {
  INACTIVITY_TIMEOUT: 20 * 60 * 1000, // 20 minutes in milliseconds
  WARNING_TIME: 1 * 60 * 1000, // 1 minute warning before logout
  ENABLED: true // Enable/disable auto-logout feature
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
